// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import FastClick from 'fastclick'
// import 'lib-flexible'
import 'amfe-flexible'
import Element from 'element-ui'

import 'normalize.css/normalize.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'print-js/dist/print.css'

import '@/styles/media.less'
import '@/styles/common.less'

import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(Element)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    // FastClick.attach(document.body)
  }, false)
}



// WEBPACK FOOTER //
// ./src/main.js